import type { StorageKey } from "@exonn/storage";
import type { UserResource } from "@exonn/js-sdk";

export const getUserDataStorageKey = ({
  user,
  key,
}: {
  user: UserResource;
  key: StorageKey;
}): StorageKey => {
  return {
    name: `user-data-${user.id}-${key.name}`,
    version: key.version,
  };
};
